export default "__VITE_ASSET__Cjlr8wPC__"